<div class="modal-header d-flex flex-column align-items-start position-relative">
  <button type="button" class="btn-close position-absolute top-0 end-0 m-3" aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>

  <div class="d-flex align-items-center gap-3 w-100 pr-4">
    @if (gameTable.organization?.organizationLogo) {
      <img [src]="gameTable.organization!.organizationLogo" alt="Logo" width="48" height="48" class="rounded-circle"
           style="background-color: var(--app-bg);">
    }
    <div>
      <h4 class="modal-title mb-0 fw-bold">{{ gameTable.organization?.organizationName || 'Organizzazione' }}</h4>
      <p class="text-muted mb-0 small">Tavoli a disposizione: {{ gameTable.maxPlayers || 1 }}</p>
    </div>
  </div>
</div>

<div class="modal-body">
  <div class="mb-3">
    <input type="text" class="form-control" placeholder="Cerca gioco..." [(ngModel)]="searchQuery">
  </div>

  @if (filteredGames.length > 0) {
    <div class="list-group list-group-flush border rounded-2">
      @for (game of filteredGames; track game.id) {
        <div class="list-group-item d-flex justify-content-between align-items-center py-2">
          <div class="fw-bold">{{ game.gameName }}</div>
          @if (game.yearPublished) {
            <span class="badge bg-secondary rounded-pill">{{ game.yearPublished }}</span>
          }
        </div>
      }
    </div>
  } @else {
    <div class="text-center py-4 text-muted border rounded-2" style="background-color: var(--app-bg);">
      Nessun gioco trovato in lista.
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Chiudi</button>
</div>
